import React, { Children, cloneElement, FC, isValidElement, PropsWithChildren } from 'react';
import { Typography, TypographyProps } from '../typography';

export type TypofallbackProps = PropsWithChildren & TypographyProps;

export const Typofallback: FC<TypofallbackProps> = ({ children, ...props }) => {
  const onlyText = Children.toArray(children).every(
    child => !isValidElement(child) && (typeof child === 'string' || typeof child === 'number')
  );

  if (onlyText) {
    return <Typography {...props}>{children}</Typography>;
  }
  if (isValidElement(children)) {
    return Children.map(children, child => cloneElement(child, { ...props, ...child.props }));
  }
  return children;
};
